const sendErrorEventToDataLayer = (message, error_type) => {
    if (!dataLayer) {
        return;
    }

    dataLayer.push({
        event: 'error',
        error_message: message,
        error_type,
        error_line: ''
    });
};

export const analyticsRequestError = error => sendErrorEventToDataLayer(error, 'server error');

export const analyticsFormValidationError = inputs =>
    inputs.forEach(input => sendErrorEventToDataLayer(`${input} is invalid`, 'customer error'));
